/**
 * The scope /results starts on, before its "no graded plays → All results"
 * fallback is considered. An explicit `?scope=me` (the Release Center's
 * pending-picks link) wins on /results; otherwise the scope the visitor last
 * picked on this route, if the route has a My/All toggle at all.
 *
 * Returning a scope skips the fallback: a member whose picks are all still
 * pending has no graded plays, so the fallback would send the pending-picks
 * link to All results, where those picks aren't listed.
 */
export function seededScope({
  baseUserId,
  searchScope,
  remembered,
}: {
  baseUserId: API.Id | 'me' | 'archive';
  searchScope?: unknown;
  remembered?: 'me' | 'archive';
}): 'me' | 'archive' | undefined {
  if (baseUserId === 'me' && searchScope === 'me') {
    return 'me';
  }

  return baseUserId === 'me' || baseUserId === 'archive' ? remembered : undefined;
}
